import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { AssetTableRow } from '../../data-maintenance.model';
import { IconV3Component } from '@gea/digital-ui-lib';

@Component({
  selector: 'app-file-preview-container',
  imports: [PdfViewerModule, IconV3Component],
  templateUrl: './file-preview-container.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class FilePreviewContainerComponent {
  availableFileIcons = [
    '7z',
    'aac',
    'ai',
    'archive',
    'arj',
    'audio',
    'avi',
    'css',
    'csv',
    'dbf',
    'doc',
    'docx',
    'dwg',
    'exe',
    'fla',
    'flac',
    'gif',
    'html',
    'iso',
    'jpg',
    'js',
    'json',
    'mdf',
    'menu-dots',
    'mp2',
    'mp3',
    'mp4',
    'mxf',
    'nrg',
    'pdf',
    'png',
    'ppt',
    'psd',
    'rar',
    'rtf',
    'svg',
    'text',
    'tiff',
    'txt',
    'unknown',
    'video',
    'wav',
    'wma',
    'xls',
    'xlsx',
    'xml',
    'zip',
  ];

  @Input() asset!: AssetTableRow;

  getIconFileType(): string {
    return this.asset?.fileType?.split('.').pop()?.toLowerCase() ?? '';
  }
}
